export enum AssessmentStatusEnum {
  InProgress = "InProgress",
  Submitted = "Submitted",
  Voided = "Voided",
}
